export default {
   props: {
      pDictionary: {
         type: Object,
         default: function() {
            return {};
         }
      },
      pCurrencies: {
         type: Array,
         default: function() {
            return [];
         }
      },
      pLanguage: {
         type: String,
         default: function() {
            return 'en';
         }
      },
      pCalendarConfig: {
        type: Object,
        default: function() {
           return {
              dateFormat: 'mm/dd/yy',
              dayPosition: 1,
              monthPosition: 2,
              yearPosition: 3
           }
        }
      },
      pUrls: {
         type: Object,
         default: function() {
            return {};
         }
      },
      pSrc: String,
      pSrcId: String,
      pThousandDelimiter: {
         type: [String,RegExp],
         default: function() {
            return "";
         }
      },
      pDecimalDelimiter: {
         type: String,
         default: function() {
            return "."
         }
      }
   }
}